<template>
    <!-- 热门活动详情 -->
    <div class="hot_activity_detail">
        <div class="main" v-if="params">
            <!-- 面包屑 -->
            <div class="breadcrumb m">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/eight_min' }">路演创赛</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/eight_min_hot_activity' }">热门活动</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/eight_min_hot_activity' }">{{params.title}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="m">
                <!-- 活动预告 -->
                <div class="foreshow">
                    <!-- 左边图片 -->
                    <div class="left_img">
                        <img
                                :src="params.coverPath"
                                alt=""
                        >
                    </div>
                    <!-- 右边详情 -->
                    <div class="right_detail">
                        <!-- 标题 -->
                        <h3>{{params.title}}</h3>
                        <!-- 详情信息 -->
                        <div class="detail_info">
                            <div class="info_left">
                                <i class="el-icon-s-custom"></i>
                                <span>主办单位</span>
                            </div>
                            <div class="info_right">
                                <span>暂无</span>
                            </div>
                        </div>
                        <div class="detail_info">
                            <div class="info_left">
                                <i class="el-icon-time"></i>
                                <span>时间</span>
                            </div>
                            <div class="info_right">
                                <!-- <span>2019年7月24日 14:00 ～ 2019年7月24日 17:00</span> -->
                                <span>{{params.activity_date}}</span>
                            </div>
                        </div>
                        <div class="detail_info">
                            <div class="info_left">
                                <i class="el-icon-location"></i>
                                <span>地点</span>
                            </div>
                            <div class="info_right">
                                <span>{{params.address || '暂无'}}</span>
                            </div>
                        </div>
                        <!-- 票种类 -->
<!--                        <div class="kind">-->
<!--                            <div class="kind_left">-->
<!--                                <i class="el-icon-tickets"></i>-->
<!--                                <span>票种</span>-->
<!--                            </div>-->
<!--                            <div class="kind_right">-->
<!--                                <span>免费票</span>-->
<!--                            </div>-->
<!--                            <div class="kind_right">-->
<!--                                <span>580元普通票</span>-->
<!--                            </div>-->
<!--                            <div class="kind_right">-->
<!--                                <span>1280元VIP票</span>-->
<!--                            </div>-->
<!--                        </div>-->
                        <!-- 底部按钮 -->
                        <div class="bottom_btn">
                            <div class="bottom_btn_left">
                                <el-button type="primary" class="apply_btn" @click="dialogFormVisible = true">我要报名</el-button>
<!--                                <el-button type="primary" class="apply_btn" disabled>我要报名</el-button>-->
                                <!--<div class="collect_btn">-->
                                <!--<el-button class="examine_btn" @click="clickCollect">-->
                                <!--<i class="el-icon-star-off"></i>-->
                                <!--收藏-->
                                <!--</el-button>-->

                                <!--收藏按钮-->
<!--                                <div class="collect_btn">-->
<!--                                    <div class="collecting" @click="collect" v-if="true">-->
<!--                                        <i class="el-icon-star-off"></i>-->
<!--                                        <span>收藏</span>-->
<!--                                    </div>-->
<!--                                    <div class="collecting is_active" @click="cancelCollect" v-else>-->
<!--                                        <i class="el-icon-star-off"></i>-->
<!--                                        <span>已收藏</span>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <!--</div>-->
                            </div>
                            <div class="bottom_btn_right">
                                <div class="browse">
                                    <i class="el-icon-view"></i>
                                    <span>{{params.popularity||0}}人浏览</span>
                                </div>
<!--                                <div>-->
<!--                                    <i class="el-icon-star-on"></i>-->
<!--                                    <span>0收藏</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 活动内容 -->
                <div class="activity_main">
                    <div class="main_left">
                        <div class="left_title">
                            <h3>活动内容</h3>
                        </div>
                        <!-- 活动介绍 -->
                        <div class="introduce">
                            <p v-html="params.content || '暂无'"></p>
                        </div>
                        <!-- 活动信息 -->
                        <!--<div class="info_box">-->
                            <!--<div class="info">-->
                                <!--<h3>路演时间：</h3>-->
                                <!--<p>{{list[0].activity_date}}</p>-->
                            <!--</div>-->
                            <!--<div class="info">-->
                                <!--<h3>路演地点：</h3>-->
                                <!--<p>{{list[0].address}}</p>-->
                            <!--</div>-->
                            <!--<div class="info">-->
                                <!--<h3>路演形式：</h3>-->
                                <!--<p>每个项目8分钟路演+7分钟投资机构嘉宾提问</p>-->
                            <!--</div>-->
                            <!--<div class="info">-->
                                <!--<h3>拟邀约投资机构（排名不分先后）：</h3>-->
                                <!--<p>启明创投、广州金控</p>-->
                                <!--<p>粤科金控、力合资本</p>-->
                                <!--<p>三泽创投、毅达资本</p>-->
                                <!--<p>基石资本、高新投</p>-->
                                <!--<p>招商银行、广发银行</p>-->
                                <!--<p>中科粤创、中大创投</p>-->
                                <!--<p>中银粤财、聚图股权</p>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="main_right">
                        <!-- 微信扫一扫 -->
                        <div class="richScan">
                            <div class="richScan_img">
                                <img :src="erweima" alt="">
                            </div>
                            <div class="richScan_text">
                                <h3>微信扫一扫</h3>
                                <p>更多免费活动等你来哦更多免费活动等你来哦更多免费活动等你来哦</p>
                            </div>
                        </div>
                        <!-- 热门活动 -->
                        <div class="hot_activity">
                            <div class="right_title">
                                <h3>热门活动</h3>
                            </div>
                            <div class="right_list">
                                <ul>
                                    <li v-for="(item,index) in HotActivity" :key="index">
                                        <div class="list_img">
                                            <img
                                                    :src="item.coverPath"
                                                    alt=""
                                            >
                                        </div>
                                        <div class="list_text">
                                            <router-link :to="{path: '/eight_min_activity_detail',query:{id:item.id}}">
                                                <!--<router-link to="" >-->
                                                <!--<span @click="hotActivity(index)">-->
                                                <span>
                          <!--这一次我们把融资的秘密全都说出来了这一次我们把融资的秘密全都说出来了-->
                          {{item.title.length>15?item.title.slice(0,15) + '...':item.title }}
                        </span>
                                            </router-link>
                                            <p>
                                                <!--<span>7月24日</span>-->
                                                <!--<span>14:00</span>-->
                                                <span>{{item.activity_date}}</span>
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 报名表单-->
        <div class="all_dialog">
            <el-dialog title="扫一扫到壹报名小程序" :visible.sync="dialogFormVisible" center>
<!--                <div slot="title" class="apply_form_title">-->
<!--                    <h3>小程序码</h3>-->
<!--                    <p>REGISTRATION FORM</p>-->
<!--                </div>-->
<!--                <el-form-->
<!--                        :model="ruleForm"-->
<!--                        :rules="rules"-->
<!--                >-->
<!--                    <div class="merge">-->
<!--                        <el-form-item-->
<!--                                label="姓名："-->
<!--                                prop="name"-->
<!--                        >-->
<!--                            <el-input v-model="ruleForm.name"></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                                label="昵称："-->
<!--                                prop="nickname"-->
<!--                        >-->
<!--                            &lt;!&ndash; <p>昵称：</p> &ndash;&gt;-->
<!--                            <el-input v-model="ruleForm.nickname"></el-input>-->
<!--                        </el-form-item>-->
<!--                    </div>-->

<!--                    <div class="merge">-->
<!--                        <el-form-item-->
<!--                                label="手机："-->
<!--                                prop="phone"-->
<!--                        >-->
<!--                            <el-input v-model="ruleForm.phone"></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                                label="邮箱："-->
<!--                                prop="Email"-->
<!--                        >-->
<!--                            <el-input v-model="ruleForm.Email"></el-input>-->
<!--                        </el-form-item>-->
<!--                    </div>-->

<!--                    <div class="merge">-->
<!--                        <el-form-item-->
<!--                                label="公司："-->
<!--                                prop="company"-->
<!--                        >-->
<!--                            <el-input v-model="ruleForm.company"></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                                label="职位："-->
<!--                                prop="job"-->
<!--                        >-->
<!--                            <el-input v-model="ruleForm.job"></el-input>-->
<!--                        </el-form-item>-->
<!--                    </div>-->
<!--                </el-form>-->
                <div>
                    <img :src="mini_code" style="width: 195px;height: 176px;" alt="">
                </div>
<!--                <div-->
<!--                        slot="footer"-->
<!--                        class="dialog-footer"-->
<!--                >-->
<!--                    <el-button-->
<!--                            type="primary"-->
<!--                            @click="submitForm()"-->
<!--                    >提交-->
<!--                    </el-button>-->
<!--                    <el-button @click="dialogFormVisible = false">取消</el-button>-->
<!--                </div>-->
            </el-dialog>
        </div>
    </div>
</template>

<script>
import erweima from "@/assets/img/eight_min/erweima/xcx.jpg";
import mini_code from "@/assets/img/eight_min/erweima/mini_code.png";

export default {
    components: {},
    data() {
        return {
            erweima: erweima,
            mini_code: mini_code,
            list: [],
            params: null,
            HotActivity: [],//热门活动
            dialogFormVisible: false,
            ruleForm: {
                name: "",
                nickname: "",
                phone: "",
                Email: "",
                company: "",
                job: "",
            },
            rules: {
                name: [
                    {required: true, message: "请输入姓名", trigger: "blur"},
                ],
                phone: [
                    {required: true, message: "请输入手机号", trigger: "blur"},
                    {pattern: /^1[0-9]{10,10}$/, message: '手机号格式错误'}
                ],
                Email: [
                    {required: true, message: "请输入邮箱地址", trigger: "blur"},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                ],
                company: [
                    {required: true, message: "请输入公司名称", trigger: "blur"},
                ],
                job: [
                    {required: true, message: "请输入职位名称", trigger: "blur"},
                ],
            }
        };
    },
    watch: {
        $route() {
            this.getData();
        }
    },
    created() {
        this.getHotActivity();
        // console.log(this.$route.query.id);
        return this.$route.query.id ? this.getData() : '';

    },
    methods: {
        // 获取数据
        getData() {
            let params = {
                id: this.$route.query.id,
                active: true
            };
            this.api.getEightActivities(params).then(res => {
                console.log(res);
                if (res.error["err_code"] !== 0) return;
                this.params = res.obj.list[0] || {};
            });
        },
        // 热门活动接口
        getHotActivity() {
            let params = {
                pageNo: 0,
                pageSize: 6,
            };
            this.api.getEightActivities(params).then(res => {
                if (res.error["err_code"] !== 0) return;
                this.HotActivity = res.obj.list;
            });
        },
        submitForm() {
          this.$message({
            message:'暂未开放'
          })
        },
        // 收藏
        collect() {
          this.$message({
            message:'暂未开放'
          })
        },
        // 取消收藏
        cancelCollect() {
          this.$message({
            message:'暂未开放'
          })
        },
        // 热门活动
        hotActivity(index) {
            this.$router.push({path: '/eight_min_activity_detail', query: {id: this.HotActivity[index].id}})
        }
    },
};
</script>

<style lang="scss">
    // 热门活动
    .hot_activity_detail {
        background-color: #f0f2f5;

        .main {
            // background-color: #fff;
            // 活动预告
            .foreshow {
                background-color: #fff;
                padding: 20px;
                // margin: 30px 0 20px;
                margin-bottom: 20px;
                display: flex;
                // 左边图片
                .left_img {
                    width: 492px;
                    height: 278px;
                    background-color: #F0F2F5;
                    margin-right: 20px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                // 右边详情
                .right_detail {
                    flex: 1;

                    h3 {
                        font-size: 22px;
                        line-height: 50px;
                        font-weight: bold;
                        color: #4b5062;
                    }

                    // 详情信息
                    .detail_info {
                        display: flex;
                        font-size: 14px;
                        line-height: 24px;
                        font-weight: 400;
                        color: #9499a5;
                        padding-bottom: 10px;
                        // 详情信息左边
                        .info_left {
                            width: 85px;

                            i {
                                padding-right: 10px;
                            }

                            span {
                            }
                        }

                        .info_right {
                            span {
                            }
                        }
                    }

                    // 票种类
                    .kind {
                        height: 32px;
                        line-height: 32px;
                        display: flex;
                        font-size: 14px;
                        font-weight: 400;
                        color: #9499a5;
                        // 票种类左边
                        .kind_left {
                            width: 85px;

                            i {
                                padding-right: 10px;
                            }

                            span {
                            }
                        }

                        .kind_right {
                            // height: 32px;
                            margin-right: 12px;
                            // line-height: 32px;
                            border: 1px solid #d3d6db;

                            span {
                                padding: 0 12px;
                            }
                        }
                    }

                    .bottom_btn {
                        margin-top: 50px;
                        display: flex;
                        justify-content: space-between;
                        // 左边
                        .bottom_btn_left {
                            display: flex;
                            // 报名按钮
                            .apply_btn {
                                width: 132px;
                                height: 48px;
                                /*line-height: 37px;*/
                                font-size: 18px;
                                background-color: #4c84ff;
                                color: #fff;
                                cursor: pointer;
                                outline: none;
                                margin-right: 12px;
                                border-radius: 2px;
                                /*border: 1px solid #e4e5eb;*/
                            }

                            // 收藏按钮
                            .collect_btn {
                              cursor: pointer;
                                .collecting {
                                    width: 55px;
                                    height: 48px;
                                    border: 1px solid #D3D6DB;
                                    font-size: 22px;
                                    line-height: 18px;
                                    padding-top: 5px;
                                    text-align: center;
                                    color: #9499A5;
                                    box-sizing: border-box;
                                    span {
                                        display: block;
                                        font-size: 12px;
                                    }
                                }

                                .is_active{
                                    color: #4c84ff;
                                    border-color: #4c84ff;
                                }
                            }

                            .el-button:hover {
                                color: #fff;
                                border-color: #4c84ff;
                                background-color: #4c84ff;
                            }

                            .live_btn:hover {
                                border: 1px solid #4c84ff;
                                color: #4c84ff;
                            }
                        }

                        .bottom_btn_right {
                            height: 40px;
                            line-height: 40px;
                            display: flex;
                            font-size: 12px;
                            font-weight: 400;
                            color: #9499a5;

                            i {
                                padding-right: 6px;
                            }

                            .browse {
                                padding-right: 20px;
                            }
                        }
                    }
                }
            }

            // 活动内容
            .activity_main {
                padding-bottom: 50px;
                display: flex;
                // 左边内容
                .main_left {
                    width: 880px;
                    padding: 0 20px;
                    box-sizing: border-box;
                    background-color: #fff;
                    margin-right: 20px;

                    .left_title {
                        h3 {
                            height: 50px;
                            line-height: 50px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #4b5062;
                            border-bottom: 2px solid #eeeff2;
                        }
                    }

                    // 活动介绍
                    .introduce {
                        overflow: hidden;
                        img{
                            max-width: 100%;
                        }
                        p {
                            font-size: 14px;
                            line-height: 24px;
                            font-weight: 400;
                            color: #4b5062;
                            padding: 20px 0;
                        }

                        .left_img {
                            width: 840px;
                            height: 366px;
                            background-color: #F0F2F5;
                        }
                    }

                    // 活动信息盒子
                    .info_box {
                        // 活动信息
                        .info {
                            padding-bottom: 25px;
                            text-align: center;

                            h3 {
                                font-size: 14px;
                                line-height: 24px;
                                font-weight: bold;
                                color: #4b5062;
                            }

                            p {
                                font-size: 14px;
                                line-height: 24px;
                                font-weight: normal;
                                color: #4b5062;
                            }
                        }
                    }
                }

                // 右边内容
                .main_right {
                    width: 300px;
                    // 微信扫一扫
                    .richScan {
                        background-color: #fff;
                        padding: 20px;
                        margin-bottom: 20px;
                        display: flex;

                        .richScan_img {
                            width: 80px;
                            height: 80px;
                            background-color: #F0F2F5;
                            margin-right: 20px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .richScan_text {
                            flex: 1;

                            h3 {
                                font-size: 18px;
                                line-height: 45px;
                                font-weight: 400;
                                color: #4b5062;
                            }

                            p {
                                height: 40px;
                                font-size: 14px;
                                line-height: 20px;
                                font-weight: 400;
                                color: #4b5062;
                                width: 155px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }

                    // 热门活动
                    .hot_activity {
                        background-color: #fff; // 右边标题
                        .right_title {
                            height: 50px;
                            line-height: 50px;
                            border-bottom: 2px solid #eeeff2;
                            padding: 0 20px;

                            h3 {
                                font-size: 16px;
                                font-weight: 400;
                                color: #4b5062;
                            }
                        }

                        // 列表
                        .right_list {
                            padding: 20px 20px 0;

                            ul {
                                background-color: #fff;

                                li {
                                    display: flex;
                                    padding-bottom: 20px;
                                }
                            }

                            // 图片
                            .list_img {
                                width: 130px;
                                height: 70px;
                                margin-right: 10px;
                                background-color: #F0F2F5;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            // 文本
                            .list_text {
                                flex: 1;
                                padding-top: 3px;

                                a {
                                    font-size: 14px;
                                    line-height: 20px;
                                    font-weight: 400;
                                    color: #4b5062;

                                    span {
                                    }
                                }

                                a:hover {
                                    color: #4c84ff;
                                }

                                p {
                                    font-size: 12px;
                                    line-height: 22px;
                                    font-weight: 400;
                                    color: #9499a5;

                                    span:first-child {
                                        padding-right: 7px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        div.all_dialog .el-dialog__wrapper{
            display: flex;
            align-items: center;
        }
        div.el-dialog {
            width: 300px;
            border-radius: 6px;
            margin-top: 0px !important;
            // 对话框标题
            /*.apply_form_title {*/
            /*    h3 {*/
            /*        font-size: 16px;*/
            /*        line-height: 24px;*/
            /*        font-weight: 400;*/
            /*        color: #4a586f;*/
            /*    }*/

            /*    p {*/
            /*        font-size: 20px;*/
            /*        line-height: 34px;*/
            /*        font-weight: 400;*/
            /*        color: #cfdce9;*/
            /*    }*/
            /*}*/

            .el-dialog__body {
                padding: 10px;
                text-align: center;
                .el-form-item__content {
                    width: 230px;

                    input {
                        height: 34px;
                    }
                }
            }

            .merge {
                display: flex;
                justify-content: space-between;
            }

            /*.el-dialog__header {*/
            /*    padding: 18px 20px;*/
            /*    width: 100%;*/
            /*    height: 80px;*/
            /*    box-sizing: border-box;*/
            /*    background-repeat: no-repeat;*/
            /*    background-image: url("../../../../../assets/img/eight_min/apply/apply.png");*/

            /*    .el-icon {*/
            /*        color: #fff;*/
            /*        font-size: 18px;*/
            /*    }*/

            /*    .el-icon:hover {*/
            /*        color: #FF733C;*/
            /*    }*/
            /*}*/

            .el-dialog__footer {
                height: 56px;
                background: #F8FAFDFF;
                text-align: center;
                border-radius: 0px 0px 6px 6px;
                padding: 11px;

                button {
                    font-size: 14px;
                    line-height: 10px;
                    height: 34px;
                    border-radius: 2px;
                    margin-left: 20px;
                }
            }
        }

        /* 包屑 */
        .breadcrumb_shadow{
            width: 100%;
            box-shadow:inset 0px 18px 7px -18px #C6D0DC;
        }
        .breadcrumb {
            padding: 20px 0;
            .el-breadcrumb > .el-breadcrumb__item>span{
                color: #4B5062;
            }
            .el-breadcrumb > .el-breadcrumb__item:last-child > .el-breadcrumb__inner {
                font-weight: 400;
                color: #4c84ff;
                display: block;
                max-width: 128px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .el-breadcrumb > .el-breadcrumb__item > .is-link {
                font-weight: 400;
            }
        }
    }
</style>
